import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} fill="none" {...props}>
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.333}
      d="M17.5 24.5H5.833A2.333 2.333 0 0 1 3.5 22.166V9.333c0-.644.522-1.167 1.167-1.167h11.666c.645 0 1.167.523 1.167 1.167v2.917"
    />
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.333}
      d="M10.5 14c0-.644.522-1.166 1.167-1.166h11.666c.645 0 1.167.522 1.167 1.166v8.167a2.333 2.333 0 0 1-2.333 2.333h-9.334a2.333 2.333 0 0 1-2.333-2.333V14ZM14 8.167V7a3.5 3.5 0 0 0-3.5-3.5v0A3.5 3.5 0 0 0 7 7v1.167"
    />
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.333}
      d="M15.167 16.334V17.5a2.333 2.333 0 0 0 2.333 2.334v0a2.333 2.333 0 0 0 2.333-2.334v-1.166"
    />
  </svg>
)
export default SvgComponent
